import {
  EngineeringPanel,
} from '../../features/engineering/EngineeringPanel'

export function EngineeringPlugin() {
  return (
    <div
      className="engineering-plugin-scope"
      data-genesis-plugin="engineering"
    >
      <EngineeringPanel />
    </div>
  )
}
